window.formatEffiloMoney =
  window.formatEffiloMoney ||
  function (cents) {
    if (cents == null || isNaN(cents)) return '';
    var amount = Math.round(Number(cents) / 100);
    return '₹' + amount.toLocaleString('en-IN');
  };

window.effiloDiscountLabel = function (variant) {
  if (!variant || !variant.compare_at_price || variant.compare_at_price <= variant.price) {
    return '';
  }
  var save = variant.compare_at_price - variant.price;
  var percent = Math.round((save * 100) / variant.compare_at_price);
  return percent + '% OFF';
};

window.effiloBuyNowCheckout = function (form) {
  if (!form) return;
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';
  var formData = new FormData(form);

  fetch(root + 'cart/add.js', {
    method: 'POST',
    body: formData,
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Add failed');
      window.location.href = '/checkout';
    })
    .catch(function () {
      form.requestSubmit();
    });
};

window.effiloInitPdpCartButton = function (data, el) {
  if (!data || !el || data._effiloCartButtonInit) return;
  data._effiloCartButtonInit = true;

  var ids = String(el.getAttribute('data-cart-variant-ids') || '')
    .split(',')
    .map(function (id) {
      return Number(id);
    })
    .filter(function (id) {
      return !isNaN(id) && id > 0;
    });

  data.effiloCartVariantIds = new Set(ids);

  var syncAddedToCart = function () {
    var id = data.currentVariantId != null ? Number(data.currentVariantId) : null;
    data.addedToCart = id != null && data.effiloCartVariantIds.has(id);
  };

  syncAddedToCart();
  data.$watch('currentVariantId', syncAddedToCart);

  document.body.addEventListener('shapes:cart:afteradditem', function (event) {
    var response = event && event.detail && event.detail.response;
    var variantId = response && response.variant_id;
    if (variantId == null && data.currentVariantId != null) {
      variantId = data.currentVariantId;
    }
    if (variantId != null) {
      data.effiloCartVariantIds.add(Number(variantId));
    }
    syncAddedToCart();
  });
};

(function () {
  function initEffiloPdp(root) {
    if (!root || root.dataset.effiloPdpInit === 'true') return;
    root.dataset.effiloPdpInit = 'true';

    var heroImage = root.querySelector('[data-effilo-hero-image]');
    var thumbs = root.querySelectorAll('[data-effilo-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = thumb.getAttribute('data-media-id');
        var src = thumb.getAttribute('data-media-src');
        var alt = thumb.getAttribute('data-media-alt') || '';

        if (!heroImage || !src) return;

        heroImage.innerHTML =
          '<img src="' +
          src +
          '" alt="' +
          alt.replace(/"/g, '&quot;') +
          '" loading="lazy" width="1200" height="1500">';

        thumbs.forEach(function (item) {
          item.classList.toggle('is-active', item === thumb);
        });

        if (mediaId) {
          root.dispatchEvent(
            new CustomEvent('effilo:pdp:media-change', {
              detail: { mediaId: mediaId },
            })
          );
        }
      });
    });

    root.querySelectorAll('[data-effilo-accordion]').forEach(function (accordion) {
      var trigger = accordion.querySelector('[data-effilo-accordion-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = accordion.classList.contains('is-open');
        accordion.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });

    root.querySelectorAll('[data-effilo-copy]').forEach(function (button) {
      button.addEventListener('click', function () {
        var code = button.getAttribute('data-effilo-copy');
        if (!code || !navigator.clipboard) return;

        navigator.clipboard.writeText(code).then(function () {
          var original = button.textContent;
          button.textContent = 'Copied';
          window.setTimeout(function () {
            button.textContent = original;
          }, 1500);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-effilo-pdp]').forEach(initEffiloPdp);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-effilo-pdp]');
    if (root) initEffiloPdp(root);
  });
})();
